import * as Flags from "../Flags";
import * as strings from "../../strings";

import { findGroupName } from "./GroupUtils";
import * as OldPillarDataUtils from "./OldPillarDataUtils";
import * as ArrayUtils from "./ArrayUtils";
import {
	Driver,
	User,
	UserFlag,
	UserStatusType,
	UserStatusTypeId,
	UserSubStatusType,
	AdminUserStatusType,
} from "../types/UserTypes";
import { TextElement } from "./LocaleUtils";
import * as AuthUtils from "./AuthUtils";
import * as UserSelectors from "../../store/User/User.selector";
import store from "../../store";
import { Falsy } from "../types/UtilTypes";
import { HW_APP_TYPE } from "lib/consts/HardwareConstants";

const FLAG_LOCKED = {
	id: "locked",
	name: "Locked",
};
const FLAG_NO_AUTH = {
	id: "noAuth",
	name: "No Auth",
	className: "--error",
};
const FLAG_YET_TO_SIGNUP = {
	id: "yetToSignup",
	name: "Yet To Signup",
};
const FLAG_DISABLED = {
	id: "disabled",
	name: "Disabled",
};
const FLAG_UNVERIFIED = {
	id: "unverified",
	name: "Unverified",
};
const FLAG_MANAGER_ONLY = {
	id: "managerOnly",
	name: "Manager Only",
};
export const FLAG_MANAGER_INVITED = {
	id: "managerInvited",
	name: "Manager Invited",
};

export const FLAGS = [
	FLAG_LOCKED,
	FLAG_NO_AUTH,
	FLAG_YET_TO_SIGNUP,
	FLAG_DISABLED,
	FLAG_UNVERIFIED,
	FLAG_MANAGER_ONLY,
	FLAG_MANAGER_INVITED,
];

export const USER_SUBSTATUS_PENDING_ID = "pending";
export const USER_SUBSTATUS_READ_ID = "read";
export const USER_SUBSTATUS_UNREAD_ID = "unread";
export const USER_SUBSTATUS_UNDELIVERED_ID = "undelivered";
export const USER_SUBSTATUS_UNKNOWN_ID = "unknown";
export const USER_SUBSTATUS_NEVER_ALIVE_ID = "never_alive";
export const USER_SUBSTATUS_INVITED_ID = "invited";
export const USER_SUBSTATUS_USERNAME_ID = "username";

export const USER_SUB_STATUSES: Record<UserStatusTypeId, UserSubStatusType[]> =
	{
		archived: [],
		live: [
			{
				label: strings.DRIVERS_SUB_STATUS_PRIVATE_MODE_LABEL,
				id: "long_term_private_mode",
				noUserCopy: "",
				bannerCopySingular: "",
				bannerCopyPlural: "",
				bannerCopyFilterSingular: "",
				bannerCopyFilterPlural: "",
				formTitle: "",
			},
			{
				label: strings.DRIVERS_SUB_STATUS_LOCATION_BLOCKED_LABEL,
				id: "recent_alive_location_blocked",
				noUserCopy: "",
				bannerCopySingular: "",
				bannerCopyPlural: "",
				bannerCopyFilterSingular: "",
				bannerCopyFilterPlural: "",
				formTitle: "",
			},
			{
				label: "",
				id: "recent_journey",
				noUserCopy: "",
				bannerCopySingular: "",
				bannerCopyPlural: "",
				bannerCopyFilterSingular: "",
				bannerCopyFilterPlural: "",
				formTitle: "",
			},
			{
				label: "",
				id: "recent_alive",
				noUserCopy: "",
				bannerCopySingular: "",
				bannerCopyPlural: "",
				bannerCopyFilterSingular: "",
				bannerCopyFilterPlural: "",
				formTitle: "",
			},
			{
				label: "",
				id: "recent_alive_no_recent_journey",
				noUserCopy: "",
				bannerCopySingular: "",
				bannerCopyPlural: "",
				bannerCopyFilterSingular: "",
				bannerCopyFilterPlural: "",
				formTitle: "",
			},
			{
				label: "",
				id: "recent_alive_no_journeys",
				noUserCopy: "",
				bannerCopySingular: "",
				bannerCopyPlural: "",
				bannerCopyFilterSingular: "",
				bannerCopyFilterPlural: "",
				formTitle: "",
			},
		],
		lta: [],
		manager: [],
		invited: [
			{
				name: "Username",
				label: "Username",
				id: USER_SUBSTATUS_USERNAME_ID,
				noUserCopy: strings.DRIVERS_SUB_STATUS_READ_NONE,
				bannerCopySingular: strings.READ_STATUS,
				bannerCopyPlural: strings.READ_STATUS_PLURAL,
				bannerCopyFilterSingular: strings.READ_STATUS_FILTER,
				bannerCopyFilterPlural: strings.READ_STATUS_FILTER_PLURAL,
				formTitle: strings.REMINDER_TITLE_READ,
			},
			{
				name: strings.DRIVERS_SUB_STATUS_READ_NAME,
				label: strings.DRIVERS_SUB_STATUS_READ_LABEL,
				id: USER_SUBSTATUS_READ_ID,
				noUserCopy: strings.DRIVERS_SUB_STATUS_READ_NONE,
				bannerCopySingular: strings.READ_STATUS,
				bannerCopyPlural: strings.READ_STATUS_PLURAL,
				bannerCopyFilterSingular: strings.READ_STATUS_FILTER,
				bannerCopyFilterPlural: strings.READ_STATUS_FILTER_PLURAL,
				formTitle: strings.REMINDER_TITLE_READ,
			},
			{
				label: strings.DRIVERS_SUB_STATUS_UNREAD_LABEL,
				id: USER_SUBSTATUS_UNREAD_ID,
				noUserCopy: strings.DRIVERS_SUB_STATUS_UNREAD_NONE,
				bannerCopySingular: strings.UNREAD_STATUS,
				bannerCopyPlural: strings.UNREAD_STATUS_PLURAL,
				bannerCopyFilterSingular: strings.UNREAD_STATUS_FILTER,
				bannerCopyFilterPlural: strings.UNREAD_STATUS_FILTER_PLURAL,
				formTitle: strings.REMINDER_TITLE_UNREAD,
			},
			{
				name: strings.DRIVERS_SUB_STATUS_UNDELIVERED_NAME,
				label: strings.DRIVERS_SUB_STATUS_UNDELIVERED_LABEL,
				id: USER_SUBSTATUS_UNDELIVERED_ID,
				noUserCopy: strings.DRIVERS_SUB_STATUS_UNDELIVERED_NONE,
				bannerCopySingular: strings.UNDELIVERED_STATUS,
				bannerCopyPlural: strings.UNDELIVERED_STATUS_PLURAL,
				bannerCopyFilterSingular: strings.UNDELIVERED_STATUS_FILTER,
				bannerCopyFilterPlural: strings.UNDELIVERED_STATUS_FILTER_PLURAL,
				formTitle: strings.REMINDER_TITLE_UNDELIVERED,
			},
			{
				name: strings.DRIVERS_SUB_STATUS_PENDING_NAME,
				label: strings.DRIVERS_SUB_STATUS_PENDING_LABEL,
				id: USER_SUBSTATUS_PENDING_ID,
				noUserCopy: strings.DRIVERS_SUB_STATUS_PENDING_NONE,
				bannerCopySingular: strings.PENDING_STATUS,
				bannerCopyPlural: strings.PENDING_STATUS_PLURAL,
				bannerCopyFilterSingular: strings.PENDING_STATUS_FILTER,
				bannerCopyFilterPlural: strings.PENDING_STATUS_FILTER_PLURAL,
				formTitle: strings.REMINDER_TITLE_PENDING,
			},
		],
		inactive: [
			{
				label: strings.DRIVERS_SUB_STATUS_UNINSTALLED_LABEL,
				id: "uninstalled",
				noUserCopy: strings.DRIVERS_SUB_STATUS_UNINSTALLED_NONE,
				bannerCopySingular: strings.UNINSTALLED_STATUS,
				bannerCopyPlural: strings.UNINSTALLED_STATUS_PLURAL,
				bannerCopyFilterSingular: strings.UNINSTALLED_STATUS_FILTER,
				bannerCopyFilterPlural: strings.UNINSTALLED_STATUS_FILTER_PLURAL,
				formTitle: strings.INACTIVE_TITLE_UNINSTALLED,
			},
			{
				label: strings.DRIVERS_SUB_STATUS_LOGGED_OUT_LABEL,
				id: "logged_out",
				noUserCopy: strings.DRIVERS_SUB_STATUS_LOGGED_OUT_NONE,
				bannerCopySingular: strings.LOGGED_OUT_STATUS,
				bannerCopyPlural: strings.LOGGED_OUT_STATUS_PLURAL,
				bannerCopyFilterSingular: strings.LOGGED_OUT_STATUS_FILTER,
				bannerCopyFilterPlural: strings.LOGGED_OUT_STATUS_FILTER_PLURAL,
				formTitle: strings.INACTIVE_TITLE_LOGGED_OUT,
			},
			{
				label: strings.DRIVERS_SUB_STATUS_PRIVATE_MODE_LABEL,
				id: "private_mode",
				noUserCopy: strings.DRIVERS_SUB_STATUS_PRIVATE_MODE_NONE,
				bannerCopySingular: strings.PRIVATE_MODE_STATUS,
				bannerCopyPlural: strings.PRIVATE_MODE_STATUS_PLURAL,
				bannerCopyFilterSingular: strings.PRIVATE_MODE_STATUS_FILTER,
				bannerCopyFilterPlural: strings.PRIVATE_MODE_STATUS_FILTER_PLURAL,
				formTitle: strings.INACTIVE_TITLE_PRIVATE_MODE,
			},
			{
				label: strings.DRIVERS_SUB_STATUS_LOCATION_BLOCKED_LABEL,
				id: "location_blocked",
				noUserCopy: strings.DRIVERS_SUB_STATUS_LOCATION_BLOCKED_NONE,
				bannerCopySingular: strings.LOCATION_BLOCKED_STATUS,
				bannerCopyPlural: strings.LOCATION_BLOCKED_STATUS_PLURAL,
				bannerCopyFilterSingular: strings.LOCATION_BLOCKED_STATUS_FILTER,
				bannerCopyFilterPlural: strings.LOCATION_BLOCKED_STATUS_FILTER_PLURAL,
				formTitle: strings.INACTIVE_TITLE_LOCATION_BLOCKED,
			},
			{
				label: strings.DRIVERS_SUB_STATUS_EMAIL_UNVERIFIED_LABEL,
				id: "email_unverified",
				noUserCopy: strings.DRIVERS_SUB_STATUS_EMAIL_UNVERIFIED_NONE,
				bannerCopySingular: strings.EMAIL_UNVERIFIED_STATUS,
				bannerCopyPlural: strings.EMAIL_UNVERIFIED_STATUS_PLURAL,
				bannerCopyFilterSingular: strings.EMAIL_UNVERIFIED_STATUS_FILTER,
				bannerCopyFilterPlural: strings.EMAIL_UNVERIFIED_STATUS_FILTER_PLURAL,
				formTitle: strings.INACTIVE_TITLE_EMAIL_UNVERIFIED,
			},
			{
				label: strings.DRIVERS_STATUS_INACTIVE_NAME,
				id: USER_SUBSTATUS_UNKNOWN_ID,
				ids: [USER_SUBSTATUS_NEVER_ALIVE_ID, USER_SUBSTATUS_UNKNOWN_ID],
				noUserCopy: strings.DRIVERS_STATUS_INACTIVE_NONE,
				checker: (user: User) =>
					user.status?.subType === "unknown" ||
					user.status?.subType === "never_alive",
			},
		],
	};
export const USER_SUB_STATUSES_FLAT = ArrayUtils.flatten(
	Object.values(USER_SUB_STATUSES),
);

export const USER_STATUS_INVITED: UserStatusType = {
	id: "invited",
	name: strings.DRIVERS_STATUS_INVITED_NAME,
	color: "#78909c",
	noUserCopy: strings.DRIVERS_STATUS_INVITED_NONE,
	tooltipCopy: strings.DRIVERS_STATUS_INVITED_TOOLTIP,
	substatuses: USER_SUB_STATUSES.invited,
	contactEnabled: true,
	bannerCopySingular: strings.INVITE_YET_TO_SIGNUP,
	bannerCopyPlural: strings.INVITE_YET_TO_SIGNUP_PLURAL,
	bannerCopyFilterSingular: strings.INVITE_YET_TO_SIGNUP_FILTER,
	bannerCopyFilterPlural: strings.INVITE_YET_TO_SIGNUP_FILTER_PLURAL,
	bannerCta: strings.INVITE_SEND_REMINDER,
	messageCta: strings.INVITE_REMINDER_SEND_FIRST,
	messageAgainCta: strings.INVITE_REMINDER_SEND_AGAIN,
	messageSentOn: strings.INVITE_INVITE_SENT_ON,
	messageSent: strings.INVITE_REMINDER_SENT,
	messageSentPlural: strings.INVITE_REMINDER_SENT_PLURAL,
};

export const USER_STATUS_LIVE: UserStatusType = {
	id: "live",
	substatuses: USER_SUB_STATUSES.live,
	name: strings.DRIVERS_STATUS_LIVE_NAME,
	color: "#50d09b",
	noUserCopy: strings.DRIVERS_STATUS_LIVE_NONE,
	tooltipCopy: strings.DRIVERS_STATUS_LIVE_TOOLTIP,
	bannerCopySingular: strings.LIVE_STATUS,
	bannerCopyPlural: strings.LIVE_STATUS_PLURAL,
	bannerCopyFilterSingular: strings.LIVE_STATUS_FILTER,
	bannerCopyFilterPlural: strings.LIVE_STATUS_FILTER_PLURAL,
};

export const USER_STATUS_INACTIVE: UserStatusType = {
	id: "inactive",
	name: strings.DRIVERS_STATUS_INACTIVE_NAME,
	color: "#2196F3",
	noUserCopy: strings.DRIVERS_STATUS_INACTIVE_NONE,
	tooltipCopy: strings.DRIVERS_STATUS_INACTIVE_TOOLTIP,
	substatuses: USER_SUB_STATUSES.inactive,
	contactEnabled: true,
	bannerCopySingular: strings.INACTIVE_STATUS,
	bannerCopyPlural: strings.INACTIVE_STATUS_PLURAL,
	bannerCopyFilterSingular: strings.INACTIVE_STATUS_FILTER,
	bannerCopyFilterPlural: strings.INACTIVE_STATUS_FILTER_PLURAL,
	bannerCta: strings.INACTIVE_GET_IN_TOUCH,
	messageCta: strings.INACTIVE_SEND_MESSAGE,
	messageAgainCta: strings.INACTIVE_SEND_MESSAGE_AGAIN,
	messageSentOn: strings.INACTIVE_MESSAGE_SENT_ON,
	messageSent: strings.INACTIVE_MESSAGE_SENT,
	messageSentPlural: strings.INACTIVE_MESSAGE_SENT_PLURAL,
	emailId: "INACTIVE_MESSAGE",
};

export const USER_STATUS_ARCHIVED: UserStatusType = {
	id: "archived",
	name: strings.MISC_ARCHIVED,
	color: "#78899c",
	noUserCopy: strings.DRIVERS_STATUS_ARCHIVED_NONE,
	tooltipCopy: strings.DRIVERS_STATUS_ARCHIVED_TOOLTIP,
};

export const USER_STATUS_LTA: UserStatusType = {
	id: "lta",
	name: strings.DRIVERS_STATUS_LTA_NAME,
	color: "#78899c",
	noUserCopy: strings.DRIVERS_STATUS_LTA_NONE,
	tooltipCopy: strings.DRIVERS_STATUS_LTA_TOOLTIP,
};

export const USER_STATUS_MANAGER: AdminUserStatusType = {
	id: "manager",
	color: "#fb7551",
	adminOnly: true,
};

export const USER_STATUSES = [
	USER_STATUS_LIVE,
	USER_STATUS_INACTIVE,
	USER_STATUS_INVITED,
	USER_STATUS_LTA,
	USER_STATUS_ARCHIVED,
];

export const HW_USER_STATUSES = [USER_STATUS_LIVE, USER_STATUS_INVITED];

export const ADMIN_USER_STATUSES = [USER_STATUS_MANAGER];

export const getUserParams = (user: User | Falsy): any => {
	const params = (user || {}).params || {};

	return Flags.DEMO_MODE.is() ? { ...params, insights: true } : params;
};

export const isUserTermsAccepted = (user: User | Falsy): boolean => {
	// Return true so modal isn't displayed before user object is retrieved
	if (
		!user ||
		!user.params ||
		user.params.portalTermsConditionsVersion === undefined
	) {
		return true;
	}

	return (
		!!user.portalTermsVersionAccepted &&
		user.params.portalTermsConditionsVersion <= user.portalTermsVersionAccepted
	);
};

// On by default
export const isInsightsEnabled = (user: User | Falsy): boolean => {
	const { insights } = getUserParams(user);
	return insights === true || insights === "true";
};

export const isRewardsEnabled = (user: User | Falsy): boolean => {
	const { showPortalRewards } = getUserParams(user);
	return showPortalRewards === true || showPortalRewards === "true";
};

export const isUserCompareEnabled = (user: User | Falsy): boolean => {
	const { portalUserCompareEnabled } = getUserParams(user);
	return (
		portalUserCompareEnabled === true || portalUserCompareEnabled === "true"
	);
};

export const isTargetLineEnabled = (user: User | Falsy): boolean => {
	const { targets } = getUserParams(user);
	return targets === true;
};

export const isGAEnabled = (user: User | Falsy): boolean => {
	const { gaEnabled } = getUserParams(user);
	return gaEnabled === true;
};

export const getUserGroupName = (user: User): TextElement => {
	return findGroupName(user.fleetId, user.group);
};

export const getUserStatus = (user: Driver, appType?: string) => {
	if (!user) {
		return null;
	}
	if (isUser(user) && user.archived) {
		return USER_STATUS_ARCHIVED;
	}
	if (isUser(user) && user.lta) {
		return USER_STATUS_LTA;
	}

	let status = USER_STATUSES.find((status) => status.id === user.status?.type);
	if (!status) {
		// if we don't have a status or a uid we are an invite
		if (!isUser(user)) {
			return USER_STATUS_INVITED;
		}
	}

	// Remove inactive status for hardware users
	if (appType === HW_APP_TYPE && status !== USER_STATUS_INVITED) {
		status = USER_STATUS_LIVE;
	}

	return status;
};

export const getUserSubStatus = (user: Driver, appType?: string) => {
	if (
		!user ||
		(appType === HW_APP_TYPE && user.status?.type !== USER_STATUS_INVITED.id)
	) {
		return null;
	}

	return (
		USER_SUB_STATUSES_FLAT.find((subType: any) =>
			subType.ids
				? subType.ids.includes(user.status?.subType)
				: subType.id === user.status?.subType,
		) || null
	);
};

export const getUserOnboardingStatus = (user: User | Falsy, step: string) => {
	if (!user || !user.uid) {
		return null;
	}

	return user.portalOnboarding && user.portalOnboarding[step];
};

export const isUser = (driver: Driver | Falsy): driver is User => {
	return Boolean(driver && (driver as any).uid);
};

export const getDriverKey = (user: Driver | Falsy): string => {
	if (!user) return null as any;
	return (
		user.key ||
		(isUser(user) && user.uid) ||
		btoa(user.email || "").replace(/=/g, "_")
	);
};

export const getBenchmarkDistance = (
	user: User,
	isImperial: boolean,
): TextElement => {
	if (!user) return 0;

	const { benchmarkDistance } = getUserParams(user);
	const value = isImperial
		? OldPillarDataUtils.metersToMiles(benchmarkDistance)
		: OldPillarDataUtils.metersToKilometers(benchmarkDistance);
	return (
		isImperial ? strings.UNIT_MILES_SHORT : strings.UNIT_KILOMETERS_SHORT
	).map((text) => `${value} ${text}`);
};

export const getUserFlags = (user: User): UserFlag[] => {
	const flags = [];

	if (user.account) {
		if (!user.account.valid) {
			flags.push(user.uid ? FLAG_NO_AUTH : FLAG_YET_TO_SIGNUP);
		}
		if (user.account.disabled) {
			flags.push(FLAG_DISABLED);
		}
		if (user.account.valid && !user.account.emailVerified) {
			flags.push(FLAG_UNVERIFIED);
		}
	}

	if (user.managerOnly) {
		flags.push(FLAG_MANAGER_ONLY);
	}

	if (user.locked) {
		flags.push(FLAG_LOCKED);
	}

	if (
		user.managerOnly &&
		user.account?.disabled &&
		!user.account?.emailVerified
	) {
		flags.splice(0, flags.length);
		flags.push(FLAG_MANAGER_INVITED);
	}

	return flags;
};

export const getFlagsFromIds = (flagIds: string[]) => {
	return flagIds.reduce((flags, id) => {
		const flag = FLAGS.find((flag) => flag.id === id);
		if (flag) {
			flags.push(flag);
		}
		return flags;
	}, [] as any[]);
};

export const getEmailComms = (user: User, emailId?: string) => {
	if (!emailId || !user.emailComms) {
		return {};
	}

	return user.emailComms[emailId] || {};
};

export const getUserGroupId = (
	user: User | null | undefined,
): string | null => {
	if (!user) {
		return null;
	}

	return (
		(AuthUtils.getEmulatedUserLevel()
			? AuthUtils.getEmulatedGroupId() === undefined
				? UserSelectors.selectCurrentScopeGroupId(store.getState())
				: AuthUtils.getEmulatedGroupId()
			: user.group) || null
	);
};

export const isUserActive = (user: User, opts = {}): boolean => {
	return Boolean(
		(user.signedUp || user.uid) && !user.managerOnly && !user.archived,
	);
};

export const isUserFiveKeys = (user?: User | null): boolean => {
	return Boolean(user?.variant?.fulfillmentValue === "5keysengage");
};
